module.exports = __webpack_public_path__ + "img/bristol.b84afd39.png";